import React, { useState, useEffect, useContext } from "react";
import swal from "sweetalert";
import * as Service from "../../services/Service.js";

// material components
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import makeStyles from '@mui/styles/makeStyles';
import { addDays, subDays } from "date-fns";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { useQuery } from "@tanstack/react-query";
import * as api from "../../actions/api";

import {
  Typography,
  TextField,
  Card,
  CardHeader,
  CardContent,
  Select,
  FormLabel,
  MenuItem,
  FormControl,
  Grid,
  InputLabel,
} from "@mui/material";

import Autocomplete from '@mui/material/Autocomplete';

// core components
import AfterLoginNavbar from "components/Navbars/AfterLoginNavbar.js";

// Highcharts component
import Highcharts from "highcharts/highstock";
import "highcharts/modules/exporting.js";
import "highcharts/modules/accessibility.js";
import HighchartsReact from "highcharts-react-official"; 

import DefaultFooter from "components/Footers/DefaultFooter";
import { getDefaultMonthYear,getARVFacilityList } from "../../services/Common";

import { useTranslation } from "react-i18next";
import {checkLogin, checkUserPermission,getUserActionPermission} from "../../services/CheckUserAccess";

import { Button } from "reactstrap";
import encryptionService from "../../services/encryptionService";

const ReportPage = (props) => {

  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const { t, i18n } = useTranslation();
  const menukey = "tld-transition-trend";
  const FacilityId = localStorage.getItem("FacilityId");
  const YearList = JSON.parse(localStorage.getItem("YearList"));
  const MonthList = JSON.parse(localStorage.getItem("MonthList"));
  //const Facility_List = JSON.parse(localStorage.getItem("FacilityList"));

  /* let All_Facility_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All Facility"])};
  const FacilityList = [All_Facility_label].concat(getARVFacilityList()); 
  //const FacilityList = [All_Facility_label].concat(Facility_List); 
  const bFacilitySelected = localStorage.getItem("bFacilitySelected"); */
 

  
    
/* =============Start Department, Zone, Commune, Facility Dipendency=============  */
const bFacilitySelected = localStorage.getItem("bFacilitySelected");
const UserInfo = encryptionService.decryptUserInfo();
const defaultRegionId = UserInfo == 0 ? 0 : UserInfo[0].RegionId;
const defaultZoneId = UserInfo == 0 ? 0 : UserInfo[0].ZoneId;
const defaultDistrictId = UserInfo == 0 ? 0 : UserInfo[0].DistrictId;

const objAll = { id: "0", name: t(DispensingLanguage[lan][menukey]["All"]) };

const Regionlist = JSON.parse(localStorage.getItem("Regionlist"));
Regionlist.unshift(objAll);
const [currRegionId, setcurrRegionId] = useState(
  bFacilitySelected == 1 ? defaultRegionId : 0
);
const [chosenValuesRegion, setChosenValuesRegion] = useState(
  bFacilitySelected == 1
    ? (Regionlist.find((list) => list.id == defaultRegionId) ?? null)
    : objAll
);

let TempZSList = useState([]);
const [ZoneList, setZoneListLocal] = useState(TempZSList);
//const [currZoneId, setcurrZoneId] = useState(0);
const [currZoneId, setcurrZoneId] = useState(
  bFacilitySelected == 1 ? defaultZoneId : 0
);
const [chosenValuesZone, setChosenValuesZone] = useState({});

let TempCommuneList = useState([]);
const [CommuneList, setCommuneListLocal] = useState(TempCommuneList);
//const [currCommuneId, setcurrCommuneId] = useState(0);
const [currCommuneId, setcurrCommuneId] = useState(
  bFacilitySelected == 1 ? defaultDistrictId : 0
);
/* const [chosenValuesDistrict, setChosenValuesDistrict] = useState({
  "DistrictId": objAll
}); */

const [chosenValuesDistrict, setChosenValuesDistrict] = useState({});

let TempFacilityList = useState([]);
const [FacilityList, setFacilityListLocal] = useState(TempFacilityList);
const [currFacilityId, setcurrFacilityId] = useState(
  bFacilitySelected == 1 ? FacilityId : 0
);
const [chosenValuesFacility, setChosenValuesFacility] = useState({});

React.useEffect(() => {
  cZoneList();
}, [currRegionId]);

React.useEffect(() => {
  cCommuneList();
}, [currRegionId, currZoneId]);

React.useEffect(() => {
  cFacilityList();
}, [currRegionId, currZoneId, currCommuneId]);

//====== Start Choosen Dropdown===========

const handleChangeChoosenRegion = (name, valueobj, value) => {
  /*  let chosenValuesDataRegion = { ...chosenValuesRegion};
chosenValuesDataRegion[name] = valueobj; */
  setChosenValuesRegion(valueobj);

  /* setFirstLoad(true); */
  setLoading(false);
  setcurrRegionId(value);

  setcurrZoneId(0);
  setcurrCommuneId(0);
  setcurrFacilityId(0);

  setChosenValuesZone(objAll);
  setChosenValuesDistrict(objAll);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenZone = (name, valueobj, value) => {
  /* let chosenValuesDataZone = { ...chosenValuesZone};
chosenValuesDataZone[name] = valueobj; */
  setChosenValuesZone(valueobj);

  /* setFirstLoad(true); */
  setLoading(false);
  setcurrZoneId(value);

  setcurrCommuneId(0);
  setcurrFacilityId(0);

  setChosenValuesDistrict(objAll);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenDistrict = (name, valueobj, value) => {
  /* let chosenValuesDataDistrict = { ...chosenValuesDistrict};
chosenValuesDataDistrict[name] = valueobj; */
  setChosenValuesDistrict(valueobj);

  setLoading(false);
  setcurrCommuneId(value);

  setcurrFacilityId(0);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenFacility = (name, valueobj, value) => {
  /*  let chosenValuesDataFacility = { ...chosenValuesFacility};
chosenValuesDataFacility[name] = valueobj; */
  setChosenValuesFacility(valueobj);

  setLoading(false);
  setcurrFacilityId(value);
};

//====== End Choosen Dropdown===========

const cZoneList = () => {
  let ZoneListParam = {
    action: "Zonelist",
    RegionId: currRegionId,
    FacilityId: FacilityId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", ZoneListParam)
    .then((res) => {
      let All_Zone_label = objAll;
      const Zone_List = [All_Zone_label].concat(res.datalist);
      setZoneListLocal(Zone_List);

      let defaultZoneDDD =
        (Zone_List.find((list) => list.id == currZoneId) ?? null);
      /* let chosenValuesDataZoneAA = {};
      chosenValuesDataZoneAA["ZoneId"] = defaultZoneDDD; */
      setChosenValuesZone(defaultZoneDDD);
    })
    .catch((err) => {});
};

const cCommuneList = () => {
  let CommuneListParam = {
    action: "Communelist",
    RegionId: currRegionId,
    ZoneId: currZoneId,
    FacilityId: FacilityId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", CommuneListParam)
    .then((res) => {
      let All_Commune_label = objAll;
      const Commune_List = [All_Commune_label].concat(res.datalist);
      setCommuneListLocal(Commune_List);

      let defaultCommune =
        (Commune_List.find((list) => list.id == currCommuneId) ?? null);
      /* let chosenValuesDataCommune = {};
    chosenValuesDataCommune["DistrictId"] = defaultCommune; */
      setChosenValuesDistrict(defaultCommune);
    })
    .catch((err) => {});
};

const cFacilityList = () => {
  let FacilityListParam = {
    action: "ARVFacilityListByDepartmentZoneCommune",
    RegionId: currRegionId,
    ZoneId: currZoneId,
    DistrictId: currCommuneId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", FacilityListParam)
    .then((res) => {
      let All_Facility_label = objAll;
      const Facility_List = [All_Facility_label].concat(res.datalist);
      setFacilityListLocal(Facility_List);
      let defaultFacilityDDD =
        (Facility_List.find(
            (facilitylist) => facilitylist.id == currFacilityId
          ) ?? null);

      /* let chosenValuesDataFacilityAA = {};
      chosenValuesDataFacilityAA["FacilityId"] = defaultFacilityDDD; */

      setChosenValuesFacility(defaultFacilityDDD);
    })
    .catch((err) => {});
};

/* =============End Department, Zone, Commune, Facility Dipendency=============  */
 
 

  const classes = useStyles();

  const [pickerData, setPickerData] = useState([{
      startDate: subDays(new Date(), 29),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [isLoadingDashboard, setLoading] = useState(true);

  const [currYearId, setCurrYearId] = useState(
    getDefaultMonthYear().defaultYear
  );
  const [currMonthId, setCurrMonthId] = useState(
    getDefaultMonthYear().defaultMonthId
  );

  /* const [currFacilityId, setCurrFacilityId] = useState(bFacilitySelected == 1 ? FacilityId: 0); */
  const [TLDTransitionPatientsTrendData, setTLDTransitionPatientsTrendData] =   useState([]);

  const handleYearChange = (event) => {
    setCurrYearId(event.target.value);
  };

  const handleMonthChange = (event) => {
    setCurrMonthId(event.target.value);
  };

/*   const handleFacilityChange = (event) => {
    setCurrFacilityId(event.target.value);
  }; */

/*   const handleFacilityChange = (event, newValue) => {
    let rowId = '';
    if(newValue == null){
      rowId = '';
    }else{
      rowId = newValue.id;
    }

    setCurrFacilityId(rowId);
 }; */


//TLD Transition Patients Trend
const getTLDTransitionPatientsTrendChart = useQuery(
  ["dashboardTLDTransitionPatientsTrend"],
  () => api.getTLDTransitionPatientsTrendChart(currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId),
  {
    onSuccess: (data) => {
      // console.log('getTLDTransitionPatientsTrendChart Data: ', data);
      setTLDTransitionPatientsTrendData({
        chart: {
          type: "spline",
        },
        title: { 
          text: t(DispensingLanguage[lan][menukey]["TLD Transition Trend"]) + " - " + data.duration
        },
        yAxis: {
          title: {
            text: "",
          },
        },
        xAxis: {
          categories: data.category
        },
        tooltip: {
          shared: true
        },
        credits: {
          enabled: false,
        },
        series: data.seriesdata
      });

    },
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 0,//1000 * 60 * 60 * 24,
  }
);


  const [ columnsStockStatusTable, setColumnsStockStatusTable] = useState([]);
  const [ stockStatusTableData, setStockStatusTableData] = useState([]);

  const { refetch: fetchDashboardStockStatusTableData} = useQuery(
    ["dashboardStockStatusTableDataList"],
    () => api.getTLDTransitionPatientsTrendTable(currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId, menukey),
    {
    onSuccess: (data) => {

  setColumnsStockStatusTable([
       
        {
          title: "",
          field: "ActivePatient",
          //width:130, 
          headerSort: false,
        },
        
        {
          title:data.category['Month1'], 
          field:"Month1", 
          width:95, 
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month2'], 
          field:"Month2", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month3'], 
          field:"Month3", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month4'], 
          field:"Month4", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month5'], 
          field:"Month5", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month6'], 
          field:"Month6", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month7'], 
          field:"Month7", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month8'], 
          field:"Month8", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month9'], 
          field:"Month9", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month10'], 
          field:"Month10", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month11'], 
          field:"Month11", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        },
        {
          title:data.category['Month12'], 
          field:"Month12", 
          width:95,
          hozAlign: "right",
          headerHozAlign: "right",
          headerSort: false,
        }
      ]);
  
      setStockStatusTableData(data.data);

      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,//1000 * 60 * 60 * 24,
    }
  );

  useEffect(() => {
    if (currYearId > 0 && currMonthId > 0) {
      getTLDTransitionPatientsTrendChart.refetch();
      fetchDashboardStockStatusTableData();
    }
  }, [currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId]);

  const [RedirectLogin, setRedirectLogin] = React.useState(true);
  
const [hasUserPermission, setHasUserPermission] = React.useState(false);

 /*  const checkLogin = () => {
    let token = sessionStorage.getItem("token");
    if (!token) {
      swal({
        title: "Oops!",
        text: 'token expired. Please login again',
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) { 
          window.location.href = process.env.REACT_APP_BASE_NAME+`/login`;
          sessionStorage.clear();
        }
      });
    }
  }; */

  if(RedirectLogin){
    setHasUserPermission(checkUserPermission(menukey));// To check user has permission in this page
    checkLogin();
    setRedirectLogin(false);
  }

  React.useEffect(() => {
    // checkLogin();
  }, []);

  const handleDatePicker = (e) => {};


   /* =====Start of Excel Export Code==== */
   const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

   const PrintExportFunction = (reportType) => {
      let Print_finalUrl = EXCEL_EXPORT_URL + "report/tld_transition_trend_print.php";
      let currFacilityName = (FacilityList.find((Facility_List) => Facility_List.id == currFacilityId) ?? null).name;
      let currDepartmentName = (Regionlist.find((List) => List.id == currRegionId) ?? null).name;
      let currZoneName = (ZoneList.find((List) => List.id == currZoneId) ?? null).name;
      let currCommuneName = (CommuneList.find((List) => List.id == currCommuneId) ?? null).name;

 
     window.open(
      Print_finalUrl +
         "?reportType=" +
         reportType +
         "&menukey=" +
         menukey +
         "&lan=" +
         localStorage.getItem("LangCode") + 
         "&TimeStamp=" + Date.now() + 
         "&Month=" + currMonthId +
         "&Year=" + currYearId +
         "&RegionId=" + currRegionId +
         "&ZoneId=" + currZoneId +
         "&CommuneId=" + currCommuneId +
         "&FacilityId=" + currFacilityId +
         "&FacilityName=" + currFacilityName +
         "&DepartmentName=" + currDepartmentName +
         "&ZoneName=" + currZoneName +
         "&CommuneName=" + currCommuneName
     );

   };
   
   const ExcelExportFunction = (reportType) => {
    let Excel_finalUrl = EXCEL_EXPORT_URL + "report/tld_transition_trend_excel.php";
    let currFacilityName = (FacilityList.find((Facility_List) => Facility_List.id == currFacilityId) ?? null).name;
    let currDepartmentName = (Regionlist.find((List) => List.id == currRegionId) ?? null).name;
    let currZoneName = (ZoneList.find((List) => List.id == currZoneId) ?? null).name;
    let currCommuneName = (CommuneList.find((List) => List.id == currCommuneId) ?? null).name;


    window.open(
      Excel_finalUrl +
        "?reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") + 
        "&TimeStamp=" + Date.now() + 
        "&Month=" + currMonthId +
        "&Year=" + currYearId +
        "&RegionId=" + currRegionId +
        "&ZoneId=" + currZoneId +
        "&CommuneId=" + currCommuneId +
        "&FacilityId=" + currFacilityId +
        "&FacilityName=" + currFacilityName +
        "&DepartmentName=" + currDepartmentName +
        "&ZoneName=" + currZoneName +
        "&CommuneName=" + currCommuneName
    );

  };

   /* =====End of Excel Export Code==== */

  
  return (
    hasUserPermission && (
        <>
          <AfterLoginNavbar {...props} />

          <div
            className="section signup-top-padding"
            style={{
              backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
              backgroundSize: "cover",
              backgroundPosition: "top center",
              minHeight: "753px",
            }}
          >
            <div className="dashboard-pannel">
              <div className="d-flex justify-product mb-1">
                <div className="sw_page_heading">
                  <div className="sw_heading_title">
                    {t(DispensingLanguage[lan][menukey]["TLD Transition Trend"])}
                  </div>
                </div>
              </div>

              {/* start of filter */}
              <Card className="sw_card sw_filter_card">
                <CardContent className="sw_filterCardContent">
                  <Grid container spacing={1}>
                    <Grid item xs={1} sm={1}>
                      <FormControl variant="standard" className={classes.fullWidth}>
                       <InputLabel id="demo-simple-select-helper-label">
                          {DispensingLanguage[lan][menukey]["Year"]}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="YearList"
                          name="YearList"
                          value={currYearId}
                          onChange={handleYearChange}
                          fullWidth
                        label={DispensingLanguage[lan][menukey]["Year"]}>
                          {YearList.map((item, index) => {
                            return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <FormControl variant="standard" className={classes.fullWidth}>
                          <InputLabel id="demo-simple-select-helper-label">
                            {DispensingLanguage[lan][menukey]["Month"]}
                          </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="MonthList"
                          name="MonthList"
                          value={currMonthId}
                          onChange={handleMonthChange}
                          fullWidth
                        label={DispensingLanguage[lan][menukey]["Month"]}>
                          {MonthList.map((item, index) => {
                            return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                    </Grid>


                    <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="RegionId"
                            options={Regionlist}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenRegion(
                                "RegionId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesRegion}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={
                                  DispensingLanguage[lan][menukey]["Department"]
                                }
                                variant="standard"
                                id="RegionId"
                                name="RegionId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="ZoneId"
                            options={ZoneList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenZone(
                                "ZoneId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesZone}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["ZS"]}
                                variant="standard"
                                id="ZoneId"
                                name="ZoneId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="DistrictId"
                            options={CommuneList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenDistrict(
                                "DistrictId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesDistrict}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["Commune"]}
                                variant="standard"
                                id="DistrictId"
                                name="DistrictId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={3} sm={3}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="FacilityId"
                            options={FacilityList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenFacility(
                                "FacilityId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesFacility}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["Facility"]}
                                variant="standard"
                                id="FacilityId"
                                name="FacilityId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      
                    {/* <Grid item xs={3} sm={3}>
                      <FormControl className={classes.fullWidth}>
                      
                        <Autocomplete
                          autoHighlight
                          className="sw_chosen_filter"
                          id="FacilityList"
                          disableClearable
                          options={FacilityList}
                          onChange={(event, newValue) => handleFacilityChange(event, newValue)}
                          getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                          defaultValue={FacilityList[FacilityList.findIndex(facilitylist => facilitylist.id == currFacilityId)]}
                          renderOption={(props, option) => (
                            <li {...props} key={option.id ?? option.name}>
                              <Typography className="sw_fontSize">{option.name}</Typography>
                            </li>
                          )}
                          
                          renderInput={(params) => (
                          <TextField
                            {...params}
                            // label={DispensingLanguage[lan][menukey]["All Facility"]}
                            variant="standard"
                            hiddenLabel
                          />
                          )}
                        />

                      </FormControl>
                    </Grid> */}

                    <Grid item xs={6} sm={6}></Grid>
                  </Grid>
                </CardContent>
              </Card>
              {/* end of filter */}

              {/* new row */}
              <div className="row">
                <div className="col-md-12 mb-4">
                  <Card className="sw_card">
                    {/* <CardHeader
                      title={t(
                        DispensingLanguage[lan][menukey][
                          "TLD Transition Trend"
                        ]
                      )}
                    /> */}
                    <CardContent>
                      <div className="row">
                        <div className="col-md-12">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={TLDTransitionPatientsTrendData}
                          />
                        </div>
                      </div>
                    
                    </CardContent>
                  </Card>
                </div>
              </div>
              {/* end row */}

              {/* new row */}
              <div className="row">
                <div className="col-md-12">
                  <Card className="sw_card">
                    {/* <CardHeader
                      title={t(DispensingLanguage[lan][menukey]["TLD Transition Trend"])}
                    /> */}

                    <CardHeader
                      title={t(DispensingLanguage[lan][menukey]["TLD Transition Trend"])}

                      action={
                        <div className="float-end sw_btn_control">
                        <Button
                          color="info"
                          className="me-2 sw_icons"
                          onClick={() => PrintExportFunction("print")}
                        >
                          <i className="fas fa-print"></i>
                        </Button>

                        <Button
                          color="info"
                          className="me-2 sw_icons"
                          onClick={() => ExcelExportFunction("excel")}
                        >
                          <i className="far fa-file-excel"></i>
                        </Button>
                      </div>
                      }
                    />

                    <CardContent>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="uniqueName">
                          <ReactTabulator
                                columns={columnsStockStatusTable}
                                data={stockStatusTableData?stockStatusTableData:[]}
                              layout={"fitColumns"}
                            />
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
              {/* end row */}
            </div>
          </div>
        </>)
  );
};

export default ReportPage;

const useStyles = makeStyles({
  root: {
    width: "20%",
    margin: "0 1rem",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  cardDiv: {
    display: "flex",
  },
  fullWidth: {
    width: "100%",
  },
});
